import React, { Component } from "react";
import { connect } from "react-redux";
import queryString from "query-string";

import { getCurrentUser, getCurrentUserRole } from "../user/user.selectors";
import {
  getCombinedContent,
  getCombinedFilteredContent
} from "../content/content.selectors";
import * as contentActions from "../content/content.actions";
import { ContentSection, PageHeader } from "./components";

import { FeaturedContentList } from "../content/components";

import { TotalSalesBlock } from "../transaction/components";
import { UserListContainer } from "../user/components";
import SearchSelect from "../common/components/app/SearchSelect";

import { Localize } from "../../locale/localization";
import SomeButtons from "./components/SomeButtons";
import LoadMore from "./components/LoadMore";
import FeaturedPinnedContentList from "../content/components/FeaturedPinnedContentList";
import { UserRoles } from "../user/user.constants";

class HomePage extends Component {
  componentWillMount() {
    const { getTags, resetFilter } = this.props;
    getTags();

    const parsed = queryString.parse(window.location.search);
    if (!parsed.filter || parsed.filter === "") {
      resetFilter();
    }
  }

  renderSuperUserContent() {
    return (
      <ContentSection>
        <TotalSalesBlock />
        <UserListContainer />
      </ContentSection>
    );
  }

  renderSalesManagerContent() {
    return (
      <ContentSection>
        <TotalSalesBlock />
        <UserListContainer />
      </ContentSection>
    );
  }

  renderRegionManagerContent() {
    return (
      <ContentSection>
        <TotalSalesBlock />
        <UserListContainer />
      </ContentSection>
    );
  }

  renderTeamLeaderContent() {
    return (
      <ContentSection>
        <TotalSalesBlock />
        <UserListContainer />
      </ContentSection>
    );
  }

  filtersApplied = () => {
    return this.appliedFilter().length > 0;
  };

  appliedFilter = () => {
    const parsed = queryString.parse(window.location.search);
    if (parsed.filter && parsed.filter !== "") {
      return parsed.filter;
    }
    return "";
  };

  doShowMore = () => {
    const {
      content,
      filteredContent,
      getContents,
      getFilteredContents
    } = this.props;
    if (this.filtersApplied()) {
      const page =
        (filteredContent.page ? parseInt(filteredContent.page, 10) : 0) + 1;
      getFilteredContents([this.appliedFilter()], page);
    } else {
      const page = (content.page ? content.page : 0) + 1;
      getContents(page);
    }
  };

  renderContent() {
    const { filteredContent, currentUser } = this.props;
    let pinned = filteredContent.filter(item => item.pinned);
    let regular = filteredContent.filter(item => !item.pinned);

    let showMore;
    if (this.filtersApplied()) {
      showMore = filteredContent.showMore;
    } else {
      const { content } = this.props;
      showMore = content.showMore;
      if (content.page === -1) {
        // limit the number of articles
        let availableCount = pinned.length + regular.length,
          maxCount = 40;
        showMore = showMore && maxCount > availableCount;

        if (maxCount < pinned.length) {
          pinned = pinned.slice(0, maxCount);
        }
        maxCount -= pinned.length;
        regular = regular.slice(0, Math.max(maxCount, 0));
      }
    }

    // Score card
    if (
      currentUser.role === UserRoles.TEAMLEADER ||
      currentUser.role === UserRoles.SELLER
    ) {
      const index = regular.length > 0 ? 1 : 0;
      regular.splice(index, 0, {
        type: "score",
        _id: "0",
        score: currentUser.score
      });
    }

    return (
      <div>
        <ContentSection>
          <FeaturedPinnedContentList items={pinned} type="news" />
          <FeaturedContentList items={regular} type="news" />
          {showMore && <LoadMore onClick={this.doShowMore} />}
          <SomeButtons />
        </ContentSection>
      </div>
    );
  }

  render() {
    const { currentUser, tags } = this.props;

    return (
      <div>
        <PageHeader
          title={`<strong>${Localize("root.header")}</strong>,<br /> ${
            currentUser.firstName
          }`}
        />
        <SearchSelect tags={tags} />
        {this.renderContent()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const currentUser = getCurrentUser(state);
  const role = getCurrentUserRole(state);
  const content = getCombinedContent(state);
  const filteredContent = getCombinedFilteredContent(state);
  const tags = state.entities.content.tags;
  const isFetching =
    state.entities.content.isFetching || state.entities.content.isFetchingTags;

  return {
    currentUser,
    role,
    content,
    filteredContent,
    isFetching,
    tags
  };
};

const ConnectedHomePage = connect(mapStateToProps, contentActions)(HomePage);

export default ConnectedHomePage;



// WEBPACK FOOTER //
// ./src/modules/pages/HomePage.js